import _ from 'lodash';
import { E_Region } from '../apis/service/types';
export const PerPageOptions = [20, 50, 100, 200];
export function toRegion(region) {
    region = _.toUpper(region);
    if (!_.has(E_Region, region)) {
        console.error('Invalidate region:', region);
        return E_Region.US;
    }
    return region;
}
